export default __webpack_public_path__ + "static/media/gwalior-1649274_1280.b22cb92f.jpg";